import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
    switchToggleWrapper: {
        position: 'relative',
        display: 'flex',
        borderRadius: 30,
        overflow: 'visible',
        width: 46,
        height: 18,
        transition: 'background-color 0.3s ease',
        cursor: 'pointer',
    },
    componentSwitchToggleWrapper: {
        position: 'relative',
        display: 'flex',
        borderRadius: 30,
        overflow: 'visible',
        width: 38,
        height: 14,
        transition: 'background-color 0.3s ease',
        cursor: 'pointer',
    },
    switchToggleLabel: {
        flex: 1,
        textAlign: 'center',
        color: '#fff',
        zIndex: 2,
        lineHeight: '40px',
        userSelect: 'none',
        fontWeight: 500,
    },
    movableCircle: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '33.3333%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1,
        transition: 'transform 0.3s ease',
        borderRadius: '50%',
    },
    switchCircleIcon: {
        fontSize: '1.8rem',
        boxShadow:
            '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
        borderRadius: '50%',
        height: 24,
        width: 24,
    },
    componentSwitchCircleIcon: {
        fontSize: '1.8rem',
        boxShadow:
            '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
        borderRadius: '50%',
        height: 20,
        width: 20,
    },
}));
